export const getServiceBulletinColumns = (th) => [
  { field: 'qmnum', header: th('serviceBulletinReport.columns.bulletinNumber'), frozen: true },
  { field: 'bulletinName', header: th('serviceBulletinReport.columns.bulletinName'), frozen: true },
  { field: 'bulletinDescription', header: th('serviceBulletinReport.columns.bulletinDescription') },
  { field: 'sasiNo', header: th('serviceBulletinReport.columns.chassisNumber') },
  { field: 'partNo', header: th('serviceBulletinReport.columns.partNumber') },
  { field: 'partDescription', header: th('serviceBulletinReport.columns.partDescription') },
  { field: 'partType', header: th('serviceBulletinReport.columns.partType') },
  { field: 'menge', header: th('serviceBulletinReport.columns.quantity') },
  { field: 'meins', header: th('serviceBulletinReport.columns.unit') },
  { field: 'kurztext', header: th('serviceBulletinReport.columns.shortDescription') },
];